module.exports = __webpack_public_path__ + "img/total-4.9b583a2d.png";